import {Route, Routes} from 'react-router-dom';
import Routing from 'fos-routing';
import Main from "./pages/Main.js";

const routes = <Routes><Route path={Routing.generate('_directorysearch_home')} element={<Main/>}/></Routes>;

export default routes;
